import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ToggleService {
  isToggled = true;
  fixed = false;

  constructor() {}

  toggleSidebar(): void {
    if (!this.isToggled && !this.fixed) {
      this.isToggled = true;
    } else {
      this.isToggled = false;
    }
  }

  toggleSidebarFixed(): void {
    this.isToggled = false;
    this.fixed = true;
  }

  toggleSidebarFlex(): void {
    this.isToggled = true;
    this.fixed = false;
  }
}
